import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import ServicesDropdown from './ServicesDropdown';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollThreshold = window.innerHeight * 0.4;
      setIsScrolled(window.scrollY > scrollThreshold);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleContactClick = (e) => {
    e.preventDefault();
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 w-full transition-all duration-300 ease-out ${
        isScrolled ? 'bg-white/95 backdrop-blur-xl shadow-sm' : 'bg-transparent'
      }`}
      style={{ zIndex: 1050 }}
    >
      <div className="container mx-auto max-w-7xl px-6 lg:px-8">
        <nav className="flex items-center justify-between py-6">
          {/* Logo - Left */}
          <a 
            href="https://www.reasoningcompany.com/" 
            className="flex items-center gap-2 no-underline"
            style={{ 
              fontFamily: "'Inter Tight', sans-serif", 
              fontWeight: 700, 
              fontSize: '1.25rem', 
              color: '#00167a',
              textDecoration: 'none',
              letterSpacing: '-0.02em',
              transition: 'all 0.3s ease'
            }}
            aria-label="The Reasoning Company Home"
          >
            <span style={{ transition: 'all 0.3s ease' }}>
              The Reasoning Company
            </span>
          </a>

          {/* Desktop Nav Menu - Right Side */}
          <div className="hidden lg:flex items-center gap-8">
            <motion.ul 
              className="flex items-center gap-6 m-0 list-none"
              initial={false}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.2 }}
            >
              {/* Services Dropdown */}
              <li className="relative">
                <ServicesDropdown />
              </li>
              
              {/* Blog Link */}
              <motion.li 
                className="relative"
                initial={false}
                whileHover={{ x: 2 }}
                transition={{ type: 'spring', stiffness: 400, damping: 25 }}
              >
                <a 
                  className="nav-link"
                  href="https://www.reasoningcompany.com/blog"
                  style={{
                    color: 'inherit',
                    textDecoration: 'none',
                    fontSize: '1rem',
                    fontWeight: 500,
                  }}
                >
                  Blog
                </a>
              </motion.li>
            </motion.ul>

            {/* Contact Us Button - Desktop */}
            <a 
              href="#contact"
              onClick={handleContactClick}
              className="flex items-center gap-1 px-5 py-2.5 rounded-lg transition-all duration-200 hover:gap-2"
              style={{
                background: '#00167a',
                color: '#ffffff',
                textDecoration: 'none',
                fontSize: '0.9375rem',
                fontWeight: 600,
              }}
            >
              Contact Us
              <span className="transition-all duration-200">→</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="lg:hidden border-0 p-0 bg-transparent"
            type="button" 
            aria-label="Toggle navigation"
            onClick={() => {
              const nav = document.getElementById('mobile-nav');
              if (nav) {
                nav.classList.toggle('hidden');
              }
            }}
          >
            <svg 
              width="24" 
              height="24" 
              viewBox="0 0 24 24" 
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </button>
        </nav>

        {/* Mobile Menu */}
        <div id="mobile-nav" className="hidden lg:hidden pb-4">
          <ul className="flex flex-col gap-2 m-0 list-none">
            <li>
              <a 
                className="block px-3 py-2 text-neutral-700 hover:text-primary-600 transition-colors"
                href="https://www.reasoningcompany.com/services"
              >
                Services
              </a>
            </li>
            <li>
              <a 
                className="block px-3 py-2 text-neutral-700 hover:text-primary-600 transition-colors"
                href="https://www.reasoningcompany.com/blog"
              >
                Blog
              </a>
            </li>
            <li>
              <a 
                className="block px-3 py-2 text-neutral-700 hover:text-primary-600 transition-colors"
                href="#contact"
                onClick={handleContactClick}
              >
                Contact Us
              </a>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
}
